import { render } from "./layouts-header.vue?vue&type=template&id=64fbe6e4&scoped=true"
import script from "./layouts-header.vue?vue&type=script&lang=js"
export * from "./layouts-header.vue?vue&type=script&lang=js"

import "./layouts-header.vue?vue&type=style&index=0&id=64fbe6e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64fbe6e4"]])

export default __exports__